import ChartDot from './ChartDot';

/**
 * Несколько точек в одной экранной ячейке — рисуются одним кружком с числом.
 * Встаёт на место первой точки: координаты и слой берутся у неё.
 * Точка о кластере не знает — превращение делает кластер (fromDot), поэтому циклической зависимости нет
 */
class ChartCluster extends ChartDot {
  private readonly items: ChartDot[] = [];

  get dots(): ChartDot[] {
    return this.items;
  }

  append(dot: ChartDot): ChartCluster {
    this.items.push(dot);

    return this;
  }

  /** Все точки из одного слоя — кластер рисуется цветом слоя, иначе нейтральным */
  get isSingleLayer(): boolean {
    return this.items.every(dot => dot.layer === this.layer);
  }

  /** Кластер на месте точки, в которую легла следующая */
  static fromDot(dot: ChartDot): ChartCluster {
    return new ChartCluster(dot.x, dot.y, dot.layer, dot.point).append(dot);
  }
}

export default ChartCluster;
